import type { EventModel } from "./OrgRecord";

// Each helper answers false for `undefined`, an event model not yet known (the
// org record is still loading or failed to load). A caller that should show
// dataset-event UI before the record arrives checks for `undefined` first.

/** Whether the org has session events (`evt_`), readable and writable. */
export function hasSessionEvents(model: EventModel | undefined): boolean {
  return model === "dual" || model === "migrating" || model === "session";
}

/** Whether the org's dataset events (`ev_`) can be read. */
export function hasLegacyEvents(model: EventModel | undefined): boolean {
  return model === "legacy" || model === "dual" || model === "migrating";
}

/** Whether the org's dataset events (`ev_`) can be created, edited or deleted. */
export function legacyEventsWritable(model: EventModel | undefined): boolean {
  return model === "legacy" || model === "dual";
}
